import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";

const EditUser = (props) => {
  const handleUserChange = () => {};
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Item List
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <Row>
              <Col sm="6">
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control inside-form"
                    placeholder="Name"
                    defaultValue={props.user != null ? props.user.name : ""}
                    onChange={handleUserChange}
                    autoComplete="off"
                  />
                </div>
              </Col>
              <Col sm="6">
                <div className="form-group">
                  <label>email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control inside-form"
                    placeholder="Email"
                    defaultValue={props.user != null ? props.user.email : ""}
                    onChange={handleUserChange}
                    autoComplete="off"
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col sm="6">
                <div className="form-group">
                  <label>User Role</label>
                  <select
                    name="userRole"
                    className="form-control inside-form"
                    value={
                      props.user != null
                        ? props.user.admin
                          ? "admin"
                          : props.user.superAdmin
                            ? "superAdmin"
                            : props.user.editor
                              ? "editor"
                              : props.user.viewer
                                ? "reader"
                                : ""
                        : ""
                    }
                    onChange={handleUserChange}
                  >
                    <option value="admin">Admin</option>
                    <option value="superAdmin">Super Admin</option>
                    <option value="editor">Editor</option>
                    <option value="reader">Viewer</option>
                  </select>
                </div>
              </Col>
              <Col sm="6">
                <div className="form-group">
                  <label>Active</label>
                  <div className="custom-control custom-switch">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      name={"active"}
                      id={"active"}
                      defaultChecked={
                        props.user != null ? props.user.active : false
                      }
                    />
                    <label
                      className="custom-control-label not-bold"
                      htmlFor={"active"}
                    >
                      Active
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit">Save</Button>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EditUser;
